angular.module('leanlaw').controller('MatterActivitySidebarCtrl', ['$scope', '$rootScope', function ($scope, $rootScope) {
  function monthString(month) {
    return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][month];
  }
  $scope.dateFilterOptions = [{
    id: 'all',
    label: 'All'
  }, {
    id: 'active',
    label: 'Active'
  }, {
    id: 'opened',
    label: 'Opened in Period'
  }, {
    id: 'closed',
    label: 'Archived in Period'
  }, {
    id: 'activity',
    label: 'Last Activity in Period'
  }];
  const today = new Date();
  const endOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
  const previousMonthString = `${monthString(endOfPreviousMonth.getMonth())} ${endOfPreviousMonth.getFullYear()}`;
  const startOfThisWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
  const endOfWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() + 7);
  const startOfLastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 7);
  $scope.periods = [{
    label: "This Month",
    id: "thisMonth",
    dateRange: {
      startDate: new Date(today.getFullYear(), today.getMonth(), 1),
      endDate: new Date(today.getFullYear(), today.getMonth() + 1, 0)
    }
  }, {
    label: "All Time",
    dateRange: {
      startDate: null,
      //new Date(today.getFullYear() - 2, 0, 1),
      endDate: null
    }
  }, {
    label: "This Year",
    id: "thisYear",
    dateRange: {
      startDate: new Date(today.getFullYear(), 0, 1),
      endDate: new Date(today.getFullYear(), 11, 31)
    }
  }, {
    label: "Last Year",
    dateRange: {
      startDate: new Date(today.getFullYear() - 1, 0, 1),
      endDate: new Date(today.getFullYear() - 1, 11, 31)
    }
  }, {
    label: "This Week",
    dateRange: {
      startDate: startOfThisWeek,
      endDate: endOfWeek
    }
  }, {
    label: "Last Week",
    dateRange: {
      startDate: startOfLastWeek,
      endDate: startOfThisWeek
    }
  }, {
    label: "Today",
    dateRange: {
      startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
    }
  }, {
    label: `${previousMonthString} and earlier`,
    dateRange: {
      startDate: null,
      //new Date(today.getFullYear() - 2, 0, 1),
      endDate: endOfPreviousMonth
    }
  }, {
    label: previousMonthString,
    id: "lastMonth",
    dateRange: {
      startDate: new Date(endOfPreviousMonth.getFullYear(), endOfPreviousMonth.getMonth(), 1),
      endDate: endOfPreviousMonth
    }
  }, {
    label: "Custom Period",
    custom: true,
    dateRange: {
      startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
      endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate())
    }
  }];
  $scope.filter = {
    dateFilter: $scope.dateFilterOptions[0],
    dateRange: $scope.periods[1]
  };
  $scope.$watch("filter", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);
}]);